"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _renderProps = require("../../../libs/renderProps");

var _InputGroup = _interopRequireDefault(require("@insided/shared/uikit/InputGroup"));

var _excluded = ["items"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var RadioFilterSelector = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(RadioFilterSelector, _Component);

  var _super = _createSuper(RadioFilterSelector);

  function RadioFilterSelector() {
    var _this;

    (0, _classCallCheck2.default)(this, RadioFilterSelector);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      data: typeof _this.props.selectedFilterItems !== 'undefined' ? _this.props.selectedFilterItems : null
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setData", function (data) {
      _this.setState({
        data: data
      });
    });
    return _this;
  }

  (0, _createClass2.default)(RadioFilterSelector, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          name = _this$props.name,
          items = _this$props.items,
          children = _this$props.children;
      var data = this.state.data;
      return (0, _preact.h)("div", null, (0, _preact.h)("div", {
        className: "overview__filters-box-content"
      }, items.map(function (item) {
        var checked = data === item.value;
        return (0, _preact.h)("div", {
          key: item.id
        }, (0, _preact.h)(_InputGroup.default, {
          inline: true,
          name: name,
          value: String(item.value),
          title: item.name,
          type: "radio",
          formGroupClasses: "overview__filters-box-filter",
          checked: checked,
          onChange: function onChange() {
            return _this2.setData(item.value);
          }
        }));
      })), (0, _renderProps.extractRenderPropsChildren)(children)({
        data: data,
        isApplyButtonDisabled: data === null
      }));
    }
  }]);
  return RadioFilterSelector;
}(_preact.Component);

(0, _defineProperty2.default)(RadioFilterSelector, "create", function (config) {
  var items = config.items,
      rest = (0, _objectWithoutProperties2.default)(config, _excluded);
  return _objectSpread({
    component: RadioFilterSelector,
    type: 'filter',
    getPillDisplayValue: function getPillDisplayValue(data) {
      var _selectedItem$name;

      var selectedItem = items.find(function (item) {
        return item.value === data;
      });
      return (_selectedItem$name = selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.name) !== null && _selectedItem$name !== void 0 ? _selectedItem$name : '';
    },
    items: items
  }, rest);
});
var _default = RadioFilterSelector;
exports.default = _default;